import axios from 'axios'
import { cleanFilters, replaceValuesParams } from 'utils/filters'
import { useIntl } from 'react-intl'
import { SRP_TYPE } from 'enums'

export const getModelsMatchedByMaker = (filters, makes) => {
  const { maker, model } = filters
  if (!makes || !maker) return null
  const filteredMakers = maker?.split(',')?.map((makerName) => {
    const makerData = makes.find((data) => `${data?.name}`.trim()?.toLowerCase() === `${makerName}`.trim()?.toLowerCase())
    if (!makerData) return null
    const matchedModels = makerData.models.filter(
      (m) => `${model}`.trim()?.toLowerCase()?.split(',')?.includes(`${m.name}`.trim()?.toLowerCase()),
    )
    const matchedModelNames = matchedModels?.map((m) => m.name)
    return {
      maker: makerData.name,
      models: matchedModelNames.join('|'),
    }
  }).filter(Boolean)
  return filteredMakers
}

export const getMakersWithModels = (data) => {
  if (!data) return null
  const formattedData = data
    .map((item) => {
      if (item.models.trim() === '') {
        return item.maker.toLowerCase()
      }
      return `${item.maker.toLowerCase()}|${item.models.toLowerCase()}`
    })
    .join(',')
  if (formattedData.startsWith(',')) {
    return formattedData.slice(1)
  }
  return formattedData
}

export const getVehicles = async (filters, authData = {}, perPage, isDrafEasy = false, makers) => {
  const cFilter = cleanFilters(filters)

  const isFirstPage = (Object.keys(cFilter)?.length === 1 && cFilter?.page === '1') || (Object.keys(cFilter)?.length === 0)
  if (isFirstPage) {
    cFilter.firstPage = true
  }

  if (cFilter?.page === '1') {
    delete cFilter.page
  }

  const filtersData = replaceValuesParams(cFilter)
  const params = { ...filtersData }

  if (filtersData?.maker !== undefined) {
    const newModelsData = getModelsMatchedByMaker(params, makers)
    const makersWithModels = getMakersWithModels(newModelsData)
    params.maker = makersWithModels
    delete params?.model
  }

  const endpoint = isDrafEasy ? `${process.env.NEXT_PUBLIC_API_ROOT}/api/inventory/draft/easy` : `${process.env.NEXT_PUBLIC_API_ROOT}/api/inventory`
  const { data } = await axios(
    endpoint,
    {
      params: { perPage, ...params },
      timeout: 15000,
      ...authData,
    },
  ).catch((err) => {
    // eslint-disable-next-line no-console
    console.log(err) // TODO check this
  })
  return data
}

export const getSRPath = (srpType = SRP_TYPE.NORMAL, isDraftEasy = false) => {
  const { formatMessage: f } = useIntl()
  let srpBasePath
  const basePath = f({ id: 'ROUTE_SEARCH' })
  const srpFiltersBasePath = f({ id: 'ROUTE_SEARCH_FILTERS' })
  const isDraftEasyPath = f({ id: 'ROUTE_SEARCH_DRAFT_EASY' })
  const isEasyVirtualParticularPath = f({ id: 'ROUTE_SEARCH_VIRTUAL_PARTICULAR' })
  if (isDraftEasy) {
    srpBasePath = isDraftEasyPath
  } else if (srpType === SRP_TYPE.FILTERS) {
    srpBasePath = srpFiltersBasePath
  } else if (srpType === SRP_TYPE.VIRTUALS) {
    srpBasePath = isEasyVirtualParticularPath
  } else {
    srpBasePath = basePath
  }
  return srpBasePath
}
export const getAuctionsSRPath = (srpType = SRP_TYPE.NORMAL) => {
  const { formatMessage: f } = useIntl()
  let srpBasePath
  const basePath = f({ id: 'ROUTE_AUCTIONS_SEARCH' })
  const srpFiltersBasePath = f({ id: 'ROUTE_SEARCH_FILTERS' })

  if (srpType === SRP_TYPE.FILTERS) {
    srpBasePath = srpFiltersBasePath
  } else {
    srpBasePath = basePath
  }
  return srpBasePath
}
